'use strict';

angular.module('amexReconciliationApp')
  .component('bcaAccountsList', {
    templateUrl: 'scripts/views/components/bca-accounts-list.html',
    controller: function(TransactionSearchModel,
                         AccountListService,
                         BillingCycleModel,
                         BcaBillingCyclesRepository,
                         PaginationModelFactory,
                         BcaSortModel,
                         BcaFilterModel,
                         $scope,
                         UserModel,
                         roles,
                         booleanConstants,
                         $state, AdobeAnalyticsService) {
      var self = this;
      var PAGE_SIZE = 20;
      var bcaPaginationModel = PaginationModelFactory.create(PAGE_SIZE);

      self.loading = true;
      self.rowLoading = null;

      self.isSuperAdmin = UserModel.isSuperAdmin;

      self.isBCAManagerViewSelected  = UserModel.isBCAManagerViewSelected;

      self.roles = UserModel.roles();
      self.currentRole = TransactionSearchModel.role();

      self.onRoleChanged = function () {
        AccountListService.roleChange(self.currentRole);
      };

      BcaSortModel.onBcasChanged($scope, function (bcas) {
        bcaPaginationModel.repaginate(bcas);
      });

      self.pageStart = bcaPaginationModel.pageStart;
      self.pageEnd = bcaPaginationModel.pageEnd;
      self.pageSize = bcaPaginationModel.pageSize;
      self.currentPage = bcaPaginationModel.pageNumber;
      self.totalCount = bcaPaginationModel.totalCount;
      self.showPagination = bcaPaginationModel.showPagination;
      self.updateCurrentPage = bcaPaginationModel.updateCurrentPage;
      self.bcaFilter = BcaFilterModel.filter;
      self.bcas = [];
      self.booleanConstants = booleanConstants;

      var openedRow = null;

      self.$onInit = function() {
        BcaBillingCyclesRepository.get().then(function(bcas) {
          BcaFilterModel.unfilteredBcas(bcas);
        }).finally(function() {
          self.loading = false;
          if(self.bcas.length === 1) {
            var bca = self.bcas[0];
            self.toggleRow(0, bca.bcaNumber, bca.rcaNumber, bca.siteNumber);
          }
        });
      };

      bcaPaginationModel.onRecordsOnCurrentPageChanged($scope, function () {
        self.bcas = bcaPaginationModel.recordsOnCurrentPage();
      });

      self.toggleRow = function (index, bcaNumber, rcaNumber, siteNumber) {
        if(self.bcas[index].billingCycles.length === 0) { return; }

        if(openedRow === index) {
          openedRow = null;
        } else {
          if(self.bcas[index].billingCycles.length === 1) {
            self.rowLoading = index;
            BcaBillingCyclesRepository.getBillingCycles(rcaNumber, bcaNumber, siteNumber).then(function success(bcaBillingCycles) {
              self.bcas[index].billingCycles = bcaBillingCycles;
              self.rowLoading = null;
            });
          }
          openedRow = index;
        }
      };

      self.isRowOpen = function (index) {
        return openedRow === index;
      };

      self.rowspanForRow = function (index) {
        if(self.isRowOpen(index)) {
          return self.bcas[index].billingCycles.length + 1;
        } else {
          return 2;
        }
      };

      self.enableAccountTooltip = function(index) {
        return self.hasBillingCycles(index) && !self.isRowOpen(index);
      };

      self.billingCyclesForRow = function(index, bcaNumber, rcaNumber, siteNumber) {
        var emptyBillCycle = {statementKey: ''};
        var bcaKey = {'bcaNumber': bcaNumber, 'rcaNumber': rcaNumber, 'siteNumber': siteNumber};
        if (self.isRowOpen(index)) {
          return _.find(self.bcas, bcaKey).billingCycles;
        } else if (null == _.find(self.bcas, bcaKey).billingCycles) {
          return emptyBillCycle;
        } else {
          return [_.find(self.bcas, bcaKey).billingCycles[0]];
        }
      };

      self.showLockIcon = AccountListService.showLockIcon;

      self.getLockColor = AccountListService.getLockColor;

      self.getLockStatusToolTip = AccountListService.getLockStatusToolTip;

      self.hasBillingCycles = function(index) {
        return self.bcas[index].billingCycles && self.bcas[index].billingCycles.length > 0;
      };

      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      self.isAccordionOpen = function(index) {
        return  self.isRowOpen(index) && self.bcas[index].billingCycles.length > 1;
      };

      self.billingCycleStatus = function (bcaIndex, billingCycleIndex) {
        var billingCycle = self.bcas[bcaIndex].billingCycles && self.bcas[bcaIndex].billingCycles[billingCycleIndex];
        if(!billingCycle) { return ''; }

        if(billingCycle.cycleOpen) {
          return 'bcaManagerAccounts.BillingCycleOpen';
        } else {
          return 'bcaManagerAccounts.BillingCycleClosed';
        }
      };

      self.goToTransactionListForBca = function(bcaNumber, rcaNumber, siteNumber, billingCycleIndex) {
        var bca = _.find(self.bcas, {'bcaNumber': bcaNumber, 'rcaNumber': rcaNumber, 'siteNumber': siteNumber});
        var billingCycle = bca.billingCycles && bca.billingCycles[billingCycleIndex];

        if(!billingCycle) { return; }

        TransactionSearchModel.bca({
          siteNumber: bca.siteNumber,
          siteName: bca.siteName,
          bcaName: bca.bcaName,
          description: bca.description,
          rca: bca.rcaNumber,
          bca: bca.bcaNumber
        });

        if(bca.billingCycles.length === 1) {
          BcaBillingCyclesRepository.getBillingCycles(rcaNumber, bcaNumber, siteNumber).then(function success(bcaBillingCycles) {
            bca.billingCycles = bcaBillingCycles;
            goToTransactionListForBca(bca.billingCycles, billingCycle);
          });
        } else {
          goToTransactionListForBca(bca.billingCycles, billingCycle);
        }
      };

      self.enableBillingCycleTransactionTooltip = function(index){
        return self.hasBillingCycles(index) && !self.isRowOpen(index);
      };

      self.hasBcas = function() {
        return !_.isEmpty(self.bcas);
      };

      function goToTransactionListForBca(billingCycles, selectedBillingCycle) {
        BillingCycleModel.billingCycles(billingCycles);
        TransactionSearchModel.billingCycle(selectedBillingCycle);
        $state.go('transactions', {currentRole: 'bcaManager'});
      }
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/bcaAccountsList.js
// module id = 437
// module chunks = 0